import {useState} from "react";

type Section = {
  title: string;
  content: React.ReactNode;
};

type AccordionProps = {
  sections?: Section[];
};

const Accordion = ({sections}: AccordionProps) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="accordion">
      {sections?.map((section, index) => (
        <div className="accordion-item" key={index}>
          <button
            className="accordion-header"
            onClick={() => toggleAccordion(index)}>
            <span className="accordion-title">{section.title}</span>
            <span className="accordion-indicator">
              {activeIndex === index ? <span>-</span> : <span>+</span>}
            </span>
          </button>
          <div
            className={`accordion-content ${
              activeIndex === index ? "active" : ""
            }`}
            style={{
              height: activeIndex === index ? "auto" : "0",
              overflow: "hidden",
              transition: "height 0.3s ease",
            }}>
            <div>{section.content}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
